module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/login-bg-tablet-507cbbd494f3eecbfff1dc17c4ad8ed8.jpg";